import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HelpCentreService } from 'app/core/services/help-centre/help-centre.service';
import {
  WhatsNewResponse,
  WhatsNewService,
} from '../../core/services/whats-new/whats-new.service';
import { ButtonComponent } from '../components';
export interface WhatsNewItem {
  readonly heading: string;
  readonly body: string;
}

export interface WhatsNewData {
  readonly title: string;
  readonly showImage?: boolean;
  readonly imageUrl?: string;
  readonly imageAlt?: string;
  readonly items: readonly WhatsNewItem[];
  readonly learnMoreUrl?: string;
}
type ViewState =
  | { readonly status: 'loading' }
  | { readonly status: 'loaded'; readonly data: WhatsNewResponse }
  | { readonly status: 'error' };

@Component({
  selector: 'sqep-whats-new-dialog',
  imports: [MatDialogModule, ButtonComponent, MatIconModule],
  templateUrl: './whats-new-dialog.component.html',
  styleUrl: './whats-new-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsNewDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<WhatsNewDialogComponent>);
  private readonly whatsNew = inject(WhatsNewService);
  protected readonly state = signal<ViewState>({ status: 'loading' });
  protected readonly skeletonRows = [0, 1, 2, 3];
  private readonly helpCentre = inject(HelpCentreService);

  constructor() {
    this.whatsNew.get().subscribe({
      next: (data) => this.state.set({ status: 'loaded', data }),
      error: () => this.state.set({ status: 'error' }),
    });
  }

  protected loadedData(): WhatsNewResponse {
    const s = this.state();
    if (s.status !== 'loaded') {
      throw new Error('loadedData() called outside loaded state');
    }
    return s.data;
  }

  close(): void {
    this.dialogRef.close();
  }

  dismiss(reason: 'got-it'): void {
    this.dialogRef.close(reason);
  }

  viewMore() {
    this.helpCentre.openArticle('release-update');
    this.close();
  }
}
